export const LAST_BUILD_TIME = '2023-06-26T16:55:52.030Z'